export default "__VITE_ASSET__MtlWlzjP__"